export enum WithdrawMethod {
  ONLINE = "ONLINE",
  CASH = "CASH",
  CARD = "CARD",
}
